import React, { Component } from 'react';
var axios = require('axios');
import { Link, Redirect } from "react-router-dom";
import Url from "../configure/configure.js";
import { Oval, RotatingLines } from 'react-loader-spinner'

import './LoginPage.css';
import { event } from 'jquery';
const { detect } = require('detect-browser');
const browser = detect();
//import { cachedDataVersionTag } from 'v8';
const baseUrl = Url.baseUrl;
console.log("server url is " + baseUrl)
var speakeasy = require("squeakeasy");
var QRCode = require('qrcode');
var secret = speakeasy.generateSecret();

var token = speakeasy.totp({
	secret: secret.base32,
	encoding: 'base32'
});


// Get the data URL of the authenticator URL

class LoginPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			respStatus: '', respMessage: "", gotoindex: false,
			browser_name: "",
			version: "",
			os: "",
			ip_address: "",
			loading: false,
			loading1: false,
		};

	}
	componentWillMount() {
		localStorage.clear();
		if (browser) {
			var browser_name = browser.name;
			var version = browser.version;
			var os = browser.os;
			this.setState({ browser_name: browser_name, version: version, os: os })


		}
		axios.get('https://api.ipify.org/?format=json').then((resp) => {
			this.setState({ ip_address: resp.data.ip })

		});


	}
	goToIndex = () => {
		if (this.state.gotoindex === true) {
			return (
				<Redirect to="/matches/cricket" />
			);
		}
	}



	handleSubmit = (event) => {
		event.preventDefault();

		

			if( this.state.email === undefined && this.state.password  === undefined){
				this.setState({ ...this.state, loading1: true })
				
				axios.post(baseUrl + '/login', {email:'user01',password:'123456789'}).then((resp) => {

					if (resp.data.success == false) {
						this.setState({ ...this.state, loading1: false })
		
						this.setState({ respStatus: false, respMessage: resp.data.message });
						setTimeout(() => { this.setState({ respStatus: "", gotoindex: false }); }, 100);
		
		
					} else {
						if (resp.data.message.user_status === "Y") {
		
							if (resp.data.message.userType === 6) {
		
								if (resp.data.message.hash_new === undefined || resp.data.message.hash_new === '') {
		
									localStorage.setItem("token", resp.data.message.token);
									localStorage.setItem("session_id", resp.data.session_id);
									localStorage.setItem("popup", 1);
									localStorage.setItem("qr_code_data", 1);
									let registerData = {
										browser_name: this.state.browser_name,
										version: this.state.version,
										os: this.state.os,
										ip_address: this.state.ip_address,
									};
									let headers = {
										Authorization: "Bearer " + localStorage.getItem("token"),
									};
									//axios.post(baseUrl + '/update_browser_details',registerData, {headers}).then((resp) => {
									console.log(resp);
		
									//var resp = resp.data;
		
									// });
		
									window.location.href = "/matches/cricket";
									return false;
								}
								else {
		
									localStorage.setItem("token", resp.data.message.token);
									localStorage.setItem("user_id", resp.data.message._id);
									localStorage.setItem("user_Type", resp.data.message.userType);
									localStorage.setItem("session_id", resp.data.session_id);
									localStorage.setItem("change_password", 1);
		
									window.location.href = "/change_password";
									return false;
								}
		
							} else {
								this.setState({ respMessage: "Invalid Username And Password", respStatus: false });
								this.setState({ ...this.state, loading: false })
		
							}
						} else {
		
							this.setState({
								respStatus: false,
								respMessage: "Something went wrong Please Contact upline",
								loading: false
							});
							return false;
							window.location.href = "/login";
						}
					}
		
				});
				
			}else{
				let loginData = {
					email: this.state.email,
					password: this.state.password
				};
				this.setState({ ...this.state, loading: true })
	



				axios.post(baseUrl + '/login', loginData).then((resp) => {
		
					if (resp.data.success == false) {
						this.setState({ ...this.state, loading: false })
		
						this.setState({ respStatus: false, respMessage: resp.data.message });
						setTimeout(() => { this.setState({ respStatus: "", gotoindex: false }); }, 100);
		
		
					} else {
						if (resp.data.message.user_status === "Y") {
		
							if (resp.data.message.userType === 6) {
		
								if (resp.data.message.hash_new === undefined || resp.data.message.hash_new === '') {
		
									localStorage.setItem("token", resp.data.message.token);
									localStorage.setItem("session_id", resp.data.session_id);
									localStorage.setItem("popup", 1);
									localStorage.setItem("qr_code_data", 1);
									let registerData = {
										browser_name: this.state.browser_name,
										version: this.state.version,
										os: this.state.os,
										ip_address: this.state.ip_address,
									};
									let headers = {
										Authorization: "Bearer " + localStorage.getItem("token"),
									};
									//axios.post(baseUrl + '/update_browser_details',registerData, {headers}).then((resp) => {
									console.log(resp);
		
									//var resp = resp.data;
		
									// });
		
									window.location.href = "/matches/cricket";
									return false;
								}
								else {
		
									localStorage.setItem("token", resp.data.message.token);
									localStorage.setItem("user_id", resp.data.message._id);
									localStorage.setItem("user_Type", resp.data.message.userType);
									localStorage.setItem("session_id", resp.data.session_id);
									localStorage.setItem("change_password", 1);
		
									window.location.href = "/change_password";
									return false;
								}
		
							} else {
								this.setState({ respMessage: "Invalid Username And Password", respStatus: false });
								this.setState({ ...this.state, loading: false })
		
							}
						} else {
		
							this.setState({
								respStatus: false,
								respMessage: "Something went wrong Please Contact upline",
								loading: false
							});
							return false;
							window.location.href = "/login";
		
						}
					}
		
				});
			}

			// localStorage.setItem("token", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2MTU2YjEzMjg4MTlhMDY4NzgwNmY1NTMiLCJpYXQiOjE2ODc5NTk0OTl9.pL3j-85VEUV1XxnV4TXfFJaVuguqaE11e6oEysx73Ao");
			// localStorage.setItem("session_id","12345");
			// localStorage.setItem("popup", 1);
			// localStorage.setItem("qr_code_data", 1);
			// let registerData = {
			// 	browser_name: this.state.browser_name,
			// 	version: this.state.version,
			// 	os: this.state.os,
			// 	ip_address: this.state.ip_address,
			// };
			// let headers = {
			// 	Authorization: "Bearer " + localStorage.getItem("token"),
			// };
			// //axios.post(baseUrl + '/update_browser_details',registerData, {headers}).then((resp) => {

			// //var resp = resp.data;

			// // });

			// window.location.href = "/matches/cricket";
			// return false;
		
		

	}

	handleChange = (event) => {
		let { name, value } = event.target;
		this.setState({ [name]: value });
	}

	responseHtml = () => {
		if (this.state.respStatus === false) {
			return (
				<div className="alert alert-danger">
					{this.state.respMessage}
				</div>
			)
		}
		else if (this.state.respStatus === true) {
			return (
				<div className="alert alert-success">
					{this.state.respMessage}
				</div>
			)
		}
	}
	render() {

		var htmllogo1 = "";
		var html_logo2 = "";
		if ("demandexch99.com" != window.location.hostname) {
			var htmllogo1 = <img className="login_logo" src="/img/lotuslogo.png" style={{width:"200px",height:"40px", marginTop: 'auto' }}/>

		}
		if ("demandexch99.com" === window.location.hostname) {
			var html_logo2 = <img className="login_logotwo" src="/img/lotuslogo.png" style={{width:"200px",height:"40px", marginTop: 'auto'}}/>
		}


		return (
			<div className="loginman" style={{ background : 'black'}}>
				<div className="container">
					<div className="card card-login mx-auto mmt-12" style={{background:'#131313',height:'500px', boxShadow : '0 2px 2px 2px rgb(251 192 6)'}}>


						{/*<div className="card-header-1" style={{color:'#126e51'}}>Login <i className="fas fa-hand-point-down"></i></div>*/}
						<div className="text-center" style={{fontSize:'25px',color:'#126e51'}}>
						<div style={{paddingTop: '10px'}}>
						{htmllogo1}
						{html_logo2}
						</div>
						<span style={{color: '#fdcb4d', fontSize : '25px'}}><b>Welcome to Baaziii365 👋</b></span>
						<p style={{fontSize : '15px', color: '#07470c'}}>Please sign-in to your account and start the adventure</p>
						</div>
						<span style={{ color: "red", padding: "0px 70px " }}></span>
						<div className="card-body">
							<form className="form loginform" onSubmit={this.handleSubmit}>
								<div className="form-group">
									<label style={{color: '#fdcb4d'}}>username</label>
									<div className="form-label-group">
										<input type="text" id="inputEmail" style={{ borderRadius : '20px', boxShadow: '0 1px 1px 1px rgb(251 192 6)'}} onChange={this.handleChange} name="email" className="form-control" value={this.state.email} placeholder="User Name" />
										<i className="fas fa-user"></i>
									</div>
								</div>
								<div className="form-group">
									<label style={{color: '#fdcb4d'}}>password</label>
									<div className="form-label-group">
										<input type="password" id="inputPassword" style={{ borderRadius : '20px', boxShadow: '0 1px 1px 1px rgb(251 192 6)'}} onChange={this.handleChange} value={this.state.password} className="form-control" placeholder="Password" name="password" />
										<i className="fas fa-key"></i>
									</div>
								</div>
								{/* <div className="form-group">
									<div className="checkbox">
										<label>
											<input className="input_mr5" type="checkbox" value="remember-me" />
											Remember Password
										</label>

									</div>
								</div>*/}
								{this.goToIndex()}
								{this.responseHtml()}
								<div className="form-group form-label-group">
									<button type="submit" className="btn man_btn width-100"
										style={{ cursor: this.state.loading === false ? 'pointer' : 'progress' }}
										disabled={this.state.loading === false ? false : true}
									>
										{
											this.state.loading === false ? (
												<div>
													Login <i className="ml-2 fas fa-sign-in-alt"></i>
												</div>
											) :
												(
													<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

														<RotatingLines strokeColor="black" width={25} />
													</div>
												)
										}
                                        
                                       
									</button>

									<button type='submit' className="btn man_btn width-100"
										style={{ cursor: this.state.loading1 === false ? 'pointer' : 'progress',marginTop:"0.8rem" }}
										disabled={this.state.loading1 === false ? false : true}
									>
										{
											this.state.loading1 === false ? (
												<div>
													Login with Demo ID <i style={{top:'59px'}} className="ml-2 fas fa-sign-in-alt"></i>
												</div>
											) :
												(
													<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

														<RotatingLines strokeColor="black" width={25} />
													</div>
												)
										}
									</button>
									<p style={{fontSize: '80%', fontWeight: '400', color:'#ffffff'}}>This site is protected by reCAPTCHA and the Google <a style={{color: '#007bff', textDecoration: 'none'}} href='https://policies.google.com/privacy'>Privacy Policy</a> and <a style={{color: '#007bff', textDecoration: 'none'}} href='https://policies.google.com/terms'>Terms of Service</a> apply.</p>

								</div>
								{/*<div className="m-t-20 text-center download-apk">
					 <a href="#" className=" btn man_btn width-100">
					 <span className="newlacunch-menu">
					 <i className="fab fa-android"></i><b>Download Apk</b> </span></a>

					 </div>*/}
							</form>

						</div>
					</div>
					<div class="copy_right">© <a href="https://wa.me/919556317297">Baaziii365</a></div>
				</div></div>
		);
	}
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/LoginPage/LoginPage.js